import { ColDef } from "@ag-grid-community/core";
import {
  MaybernTableBulkEditControllerProps,
  useMaybernTableBulkEditController as useMaybernTableBulkEditTableProps,
} from "shared/components/table/maybern/MaybernTableBulkEditController";

export interface UseBulkEditorParams<T extends object> {
  controllerProps: MaybernTableBulkEditControllerProps<T>;
  columnDefs: ColDef<T>[];
}

export const useBulkEditor = <T extends object>(
  params: UseBulkEditorParams<T>,
) => {
  const {
    gridRef,
    datasource,
    onCellValueChanged,
    getErrorForCell,
    rowData,
    onClickClear,
  } = useMaybernTableBulkEditTableProps(params.controllerProps);
  return {
    gridRef,
    rowData,
    onClickClear,
    tableProps: {
      columnDefs: params.columnDefs,
      ref: gridRef,
      onCellValueChanged,
      defaultColDef: {
        sortable: false,
      },
      enableRangeSelection: true,
      enableFillHandle: true,
      rowModelType: "serverSide" as const,
      serverSideDatasource: datasource,
      maxConcurrentDatasourceRequests: 1,
      getErrorForCell,
    },
  };
};
